<template>
  <div class="auth-panel" v-bind:class="{loaded}">
    <a-row type="flex">
      <a-col span="13" sm="13" v-if="$mq !== 'mobile' && $mq !== 'tablet'"
             style="background-image: url('/img/branding/topview.jpg')" class="side-image">
      </a-col>
      <a-col
          v-if="view === 'login' || view === 'factor_yubikey' || view === 'factor_email' || view === 'factor_missing'"
          :span="$mq | mq({mobile: 24, tablet: 24, laptop: 11, desktop: 11})" class="content">
        <h2 class="title color-white font-size-lg mb-md">
          Inloggen
        </h2>

        <a-row v-if="twoFactorValue" class="steps" style="margin: -1rem 0rem 1rem 0rem;">
          <a-col span="12" v-bind:class="{ active: view === 'login' }" style="text-align: left;">
            Stap 1
          </a-col>
          <a-col span="12"
                 v-bind:class="{ active: (view === 'factor_yubikey' || view === 'factor_email' || view === 'factor_missing') }"
                 style="text-align: right;">
            Stap 2
          </a-col>
        </a-row>

        <div v-if="view === 'login'">
          <p class="color-white mb-xs">Gebruikersnaam</p>

          <p class="mb-md">
            <a-input ref="username" class="username" v-model="username"
                     v-on:keyup.enter.native.prevent="onNextOrLogin"
                     v-bind:class="{'has-error': !usernameValid}"
                     @focus="() => {usernameValid = true}"
                     @blur="validateUsername"
            />
          </p>

          <p class="color-white mb-xs">Wachtwoord</p>

            <p class="mb-md">
            <a-input ref="password" class="password" v-model="password" type="password"
                     v-on:keyup.enter.native.prevent="onNextOrLogin"
                     v-bind:class="{'has-error': !passwordValid}"
                     @focus="() => {passwordValid = true}"
                     @blur="validatePassword"
            />
          </p>
          <p>
            <a-checkbox
                v-model="rememberUsername"
                style="padding: 0 1rem; color: white;">
              Gebruikersnaam onthouden
            </a-checkbox>
          </p>
          <p>
            <a-button v-if="!twoFactorValue" :loading="loggingIn" class="login-button"
                      size="large" type="primary" block @click="onLoginClick">
              Inloggen
            </a-button>
            <a-button v-else :loading="checkingFactor" class="next-button" size="large"
                      type="primary" block @click="onNextClick">
              Volgende
            </a-button>
          </p>
          <a-button type="link" block ghost v-on:click="showForgotPassword">
            Wachtwoord vergeten
          </a-button>
        </div>
        <div v-if="view === 'factor_missing'">
          <p class="color-white">
            Uw omgeving heeft tweefactorauthenticatie (2FA) ingeschakeld,
            maar uw account is hier nog niet voor geconfigureerd.
          </p>

          <p class="color-white">
            De beheerder van uw omgeving kan deze instelling controleren en aanpassen.
            Per e-mail zal de beheerder worden geïnformeerd.
          </p>

          <a-button size="large" type="secondary" block ghost @click="showLogin" style="margin-top: 10px;">
            Terug naar Stap 1
          </a-button>
        </div>
        <div v-if="view === 'factor_yubikey'">
          <YubikeyFactorComponent
              ref="yubikeyFactor"
              v-on:cancel="showLogin"
              v-on:submit="onFactorSubmit"
              v-on:switch-factor="showFactor"
          ></YubikeyFactorComponent>
        </div>
        <div v-if="view === 'factor_email'">
          <EmailFactorComponent
              ref="emailFactor"
              v-on:cancel="showLogin"
              v-on:submit="onFactorSubmit"
              v-on:switch-factor="showFactor"
          ></EmailFactorComponent>
        </div>
        <div v-if="factor === 'sms'">
          <p>Emailcode</p>

          <p>
            <a-input :value="otp" @change="onOTPChange"/>
          </p>

          <a-button :loading="loggingIn" class="login-button" size="large" type="primary" block
                    @click="onLoginClick">
            Inloggen
          </a-button>
        </div>
      </a-col>
      <a-col v-if="view === 'forgot_password'" :span="$mq | mq({mobile: 24, tablet: 24, laptop: 11, desktop: 11})"
             class="content">
        <ForgotPasswordComponent
            :username="defaultUsername"
            v-on:forgot-username="showForgotUsername"
            v-on:cancel="showLogin"
        ></ForgotPasswordComponent>
      </a-col>
      <a-col v-if="view === 'forgot_username'" :span="$mq | mq({mobile: 24, tablet: 24, laptop: 11, desktop: 11})"
             class="content">
        <ForgotUsernameComponent
            v-on:cancel="showForgotPassword"
        ></ForgotUsernameComponent>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import authApi from '~/api/auth'
import ForgotPasswordComponent from './ForgotPasswordComponent'
import ForgotUsernameComponent from './ForgotUsernameComponent'
import YubikeyFactorComponent from './YubikeyFactorComponent'
import EmailFactorComponent from './EmailFactorComponent'

export default {
  name: 'LoginComponent',
  components: {
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    YubikeyFactorComponent,
    EmailFactorComponent
  },
  props: {
    defaultUsername: {
      type: String,
      default: null,
    },
    twoFactor: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      view: 'login',
      factor: null,
      username: '',
      password: '',
      emailaddress: '',
      otp: '',
      twoFactorValue: false,
      rememberUsername: false,
      loggingIn: false,
      checkingFactor: false,
      requestingPasswordReset: false,
      requestingUsernameReminder: false,
      usernameValid: true,
      passwordValid: true,
      emailValid: true,
      loaded: false
    }
  },
  computed: {
    defaultRememberUsername () {
      return this.defaultUsername !== null && this.defaultUsername.length > 0
    }
  },
  methods: {
    validateUsername () {
      this.usernameValid = (this.username.length > 0)
    },
    validatePassword () {
      this.passwordValid = (this.password.length > 0)
    },
    onOTPChange (e) {
      this.otp = e.target.value
    },
    onNextOrLogin () {
      if (this.twoFactorValue) {
        return this.onNextClick()
      } else {
        return this.onLoginClick()
      }
    },
    onFactorSubmit (otp) {
      this.otp = otp
      this.onLoginClick()
    },
    onLoginClick () {
      if (!this.credentialsFilledIn()) {
        return false
      }

      this.loggingIn = true
      authApi.login(this.username, this.password, this.factor, this.otp).then(response => {
        if (response.redirect) {
          window.location = response.redirect
        } else {
          window.location = '/dashboard'
        }
      }, error => {
        this.handleLoginError(error)
      })
    },
    onRequestPasswordResetClick () {
      this.requestingPasswordReset = true
      authApi.requestPasswordReset(this.username).then(response => {
        // this.loggingIn = false;
        this.requestingPasswordReset = false
        this.view = 'password_reset_requested'
      }, error => {
        this.requestingPasswordReset = false
        this.factor = null
        this.password = ''
        this.$refs.password.focus()
        this.handlePasswordResetError(error)
      })
    },
    onRequestUsernameReminderClick () {
      this.requestingPasswordReset = true
      authApi.requestUsernameReminder(this.emailaddress).then(response => {
        // this.loggingIn = false;
        this.requestingUsernameReminder = false
        this.view = 'username_reminder_requested'
      }, error => {
        this.requestingUsernameReminder = false
        this.handleUsernameReminderError(error)
      })
    },
    credentialsFilledIn () {
      this.validateUsername()
      this.validatePassword()

      if (!this.usernameValid) {
        this.$notification['error']({
          message: 'Vul uw gebruikersnaam in',
        })
        this.$refs.username.focus()

        return false
      }

      if (!this.passwordValid) {
        this.$notification['error']({
          message: 'Vul uw wachtwoord in',
        })
        this.$refs.password.focus()

        return false
      }

      return true
    },
    onNextClick () {
      if (!this.credentialsFilledIn()) {
        return false
      }

      this.checkingFactor = true
      authApi.getFactorByCredentials(this.username, this.password, this.rememberUsername).then(response => {
        this.checkingFactor = false
        this.showFactor(response.type)
      }, error => {
        this.checkingFactor = false
        this.password = ''
        this.$refs.password.focus()
        this.handleLoginError(error)
      })
    },
    showLogin () {
      this.view = 'login'
    },
    showFactor (factor) {
      if (factor === null) {
        this.showMissingFactor()
      } else if (factor === 'yubi') {
        this.showFactorYubikey()
      } else if (factor === 'email') {
        this.showFactorEmail()
      } else {
        this.$notification['error']({
          message: 'Er is iets fout gegaan, neem aub contact met ons op',
        })
      }
    },
    showMissingFactor () {
      this.factor = null
      this.view = 'factor_missing'
    },
    showFactorYubikey () {
      this.factor = 'yubi'
      this.view = 'factor_yubikey'
    },
    showFactorEmail () {
      this.factor = 'email'
      authApi.sendEmailCode(this.username, this.password)
      this.view = 'factor_email'
    },
    showForgotPassword () {
      this.view = 'forgot_password'
    },
    showForgotUsername () {
      this.view = 'forgot_username'
    },
    handleLoginError (error) {
      if (error.response.status === 400) {
        this.$notification['error']({
          message: 'Er ging iets fout tijdens het inloggen',
        })

        let errorResponse = error.response.data

        if (typeof errorResponse.error !== 'undefined' && errorResponse.error === 'Invalid CSRF token.') {
          window.location.reload()
        }
      } else if (error.response.status === 401) {

        if (error.response.data.type && error.response.data.type === 'missing_two_factor_exception') {
          this.twoFactorValue = true
          this.onNextClick()

          return;
        } else {
          this.$notification['error']({
            message: 'Inloggen mislukt',
          })
        }
      } else if (error.response.status === 429) {
        this.$notification['error']({
          message: 'Teveel inlogpogingen',
          description: 'Wacht een minuut en probeer het nogmaals'
        })
      } else if (error.response.data.error.message.length) {
        this.$notification['error']({
          message: 'Inloggen mislukt.',
          description: error.response.data.error.message,
        })
      } else {
        this.$notification['error']({
          message: 'Er is iets fout gegaan',
        })
      }
      this.loggingIn = false
      this.factor = null
      this.password = ''

      this.showLogin()

      if (this.$refs.password) {
        this.$refs.password.focus()
      }

      if (this.$refs.yubikeyFactor) {
        this.$refs.yubikeyFactor.loading = false
      }

      if (this.$refs.emailFactor) {
        this.$refs.emailFactor.loading = false
      }
    },
    handlePasswordResetError (error) {
      this.$notification['error']({
        message: 'Er is iets fout gegaan',
      })
    },
    handleUsernameReminderError (error) {
      this.$notification['error']({
        message: 'Er is iets fout gegaan',
      })
    }
  },
  mounted () {
    this.twoFactorValue = this.twoFactor
    this.username = this.defaultUsername
    this.rememberUsername = this.defaultRememberUsername
    setTimeout(() => {
      if (this.defaultRememberUsername) {
        this.$refs.password.focus()
      } else {
        this.$refs.username.focus()
      }

      this.loaded = true
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.auth-panel {
  margin-left: auto;
  margin-right: auto;
  background: rgb(8, 95, 206);
  background: linear-gradient(25deg, rgba(8, 95, 206, 1) 48%, rgba(62, 171, 214, 1) 100%);
  color: white;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0px 0px 22px -7px rgba(0, 0, 0, 0.4);
}
@media only screen and (max-width: $screen-lg-min) {
  .auth-panel {
    max-width: 798px;

    .side-image{
      background-position-x: 10%;
    }
  }
}

.side-image {
  background-size: cover;
  background-position: center left;
}

.auth-panel .content {
  padding: 3rem 4rem;
  min-height: 35rem;
}

.auth-panel .content .title {
  font-size: 3rem !important;
  color: white !important;
}

.auth-panel .steps {
  margin: -1rem 0rem 1rem 0rem;
  font-size: 18px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
}

.auth-panel .steps .active {
  color: white;
}

.has-error {
  border-color: #ff4040;
  box-shadow: 0 0 0 2px rgba(255, 24, 24, 0.2);
}
</style>
